import { FetchLookupsResponse } from '@lib/api';

import { LookupsValue } from '../types';

export function getRejectedReasonFromLookupsResponse(
  lookupsResponse: FetchLookupsResponse,
): LookupsValue['rejectionReasons'] {
  return lookupsResponse.rejectionReasons.map((reason) => ({
    value: reason.rejectionReason,
    titleEn: reason.titleEn,
    titleAr: reason.titleAr,
  }));
}
